export default {
    success: {
        pwsuccess: {
            message: 'Password updated successfully.',
            type: 'success'
        }
    }
}
